import { Component, OnInit, ViewEncapsulation, Input, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { AppState } from '../../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';

@Component({
    selector: 'assessor-message-render',
    styleUrls: ['./assessor-message-render.component.scss'],
    templateUrl: 'assessor-message-render.component.html',
    encapsulation: ViewEncapsulation.None
})

export class AssessorMessageRender {

    // user | assessor ( feedback | message )
    @Input() lastMessage: string;

    // type message | feedback
    @Input() type: string;

    // texto para exibir
    @Input() text: string;

    // nome do assessor
    @Input() name: string;

    // novo do novo agente na conversa
    @Input() newAssessorName: string;

    // msg status sales force
    @Input() status: string;

    @ViewChild('chatMessage',  {static: true}) chatMessage;

    @ViewChild('chatMessageItem',  {static: true}) chatMessageItem;

    constructor(
        private _r: Renderer2,
        private _eL: ElementRef,
        private store: Store<AppState>
    ) { }

    ngOnInit() {
        this.checkParent();
        this.animationStart();
    }

    /**
     *
     * confere se o elemento anterior é um texto vindo do assessor
     */
    checkParent() {
        if (this.lastMessage && this.lastMessage == this.type) {
            this._r.addClass(this.chatMessage.nativeElement, 'text-sequence');
        }
    }

    animationStart() {
        // entrada
        setTimeout(() => {
            this._r.addClass(this.chatMessageItem.nativeElement, 'on-entry');
        }, 100);
    }
}
